import { API_ORIGIN } from '../services/api';
import montaukMaple from '../assets/products/montauk-maple.webp';
import sunRiseCrunch from '../assets/products/sun-rise-crunch.webp';
import goldCoastCacao from '../assets/products/gold-coast-cacao.webp';
import bayshoreBlue from '../assets/products/bayshore-blue.webp';
import productAlpha from '../assets/product-alpha.webp';

// Interim product photography, keyed by the database product id (see the seeds
// in backend/src/db.ts and the id shown in the Admin table). These are
// web-optimized WebP files committed to the repo so the storefront has real,
// varied imagery until per-product images are managed end-to-end through the
// backend/admin. Ids that aren't listed fall back to the generic composite.
export const productImagesById: Record<string, string> = {
  '1': montaukMaple,
  '2': sunRiseCrunch,
  '3': goldCoastCacao,
  '4': bayshoreBlue,
};

// Turn a stored product `image` value into a usable <img> src. Backend uploads
// are stored as a relative "/uploads/<file>" path and must be resolved against
// the API origin; absolute URLs and data URLs are passed through unchanged.
// Any other relative path (e.g. the legacy "/products/x.jpg" seed values) has
// no file behind it on the storefront, so treat it as "no image" rather than
// letting the browser render a broken <img>.
export function resolveProductImageUrl(image: string | null | undefined): string {
  if (!image) return '';
  if (/^https?:\/\//.test(image) || image.startsWith('data:')) return image;
  if (image.startsWith('/uploads/')) return `${API_ORIGIN}${image}`;
  return '';
}

// Resolve the image to display for a product on the storefront (product grid,
// cart, etc.). For now the committed id-keyed photos win so the four known
// products always show their real packaging; anything else falls back to a
// resolved backend image, then to the generic "alpha" packaging shot.
export function getProductImageSrc(product: { id: string; image?: string | null }): string {
  return productImagesById[product.id] ?? (resolveProductImageUrl(product.image) || productAlpha);
}
